import React from "react";

// CSS Styling
import "../../../styles/admin.css";
import "../../../styles/isaAcademy.css";

// Images and Icons
import NotepadPencil from "../../../images/icons/NotepadPencil.png";
import DeleteIcon from "../../../images/icons/DeleteIcon.png";

// React lottie
import Lottie from "react-lotties";
import PaperPlane from "../../../lotties/paperplane.json";

// Axios and API
import { deleteWorkshop } from "../../../api/deleteWorkshop";

// Moment.js
import moment from "moment";

// Sweet Alert v2
import Swal from "sweetalert2";

const WorkshopList = (props) => {
  const { navigate, isLoading, workshops, setLoading, fetchAllWorkshops } =
    props;

  const lottieOptions = {
    loop: true,
    autoplay: true,
    animationData: PaperPlane,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const handleDeleteWorkshop = async (workshopId) => {
    Swal.fire({
      customClass: {
        cancelButton: "cancelPostButton",
        confirmButton: "confirmPostButton",
        title: "cancelPostButtonTitle",
      },
      title: "are you sure you want to delete this? ",
      text: "Once confirmed, you can’t undo this.",
      padding: "3em",
      showCancelButton: true,
      confirmButtonColor: "white",
      cancelButtonColor: "#3085d6",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    })
      .then((res) => {
        if (res.isConfirmed) {
          setLoading(true);
          deleteWorkshop(workshopId)
            .then((res) => {
              Swal.fire({
                customClass: {
                  confirmButton: "publishButton",
                  title: "publishTitle",
                  popup: "publishPopup",
                },
                showCloseButton: true,
                confirmButtonColor: "#1F81DC",
                title: "Success!",
                text: "You have successfully deleted workshops",
                confirmButtonText: "Okay, got it!",
              });
              fetchAllWorkshops();
            })
            .catch((err) => {
              setLoading(false);
              console.log(err);
            })
            .finally(() => {
              setLoading(false);
            });
        } else {
          console.log(res);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div>
      <div className="adminPostList">
        <div className="adminPostListTitleContainer">
          <div className="adminPostListTitle">
            <p>List of Workshops</p>
          </div>
          <div className="adminPostListFunction">
            {/* filter button goes here */}
            <div className="adminPostListEachFunction addPostButton">
              <button
                onClick={() => navigate("/admin/isaAcademy-workshops/add")}
              >
                Add New
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="adminPostTable">
        <div className="adminPostTableContainer">
          <table>
            <thead>
              <tr>
                <th className="thLastModified">Last modified</th>
                <th className="thWorkshopTitle">Workshop Title</th>
                <th>Posted by</th>
                <th>Schedule</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {!isLoading && workshops.length > 0 ? (
                workshops.map((workshop) => (
                  <tr key={workshop.id} className="adminTableRow">
                    <td className="tdLastModified">
                      <div style={{ marginRight: "1em" }}>
                        {`${moment(workshop.lastModified).format(
                          "DD/MM/YYYY"
                        )}`}
                      </div>
                      <div>{moment(workshop.lastModified).format("HH:mm")}</div>
                    </td>
                    <td>{workshop.workshopTitle}</td>
                    <td>{workshop.postedBy}</td>
                    <td>
                      {workshop.schedule < 2
                        ? `${workshop.schedule} schedule`
                        : `${workshop.schedule} schedules`}
                    </td>
                    <td className="tdEdit">
                      <div
                        className="editWorkshopBtn"
                        onClick={() =>
                          navigate(
                            `/admin/isaAcademy-workshops/edit/${workshop.id}`
                          )
                        }
                      >
                        Edit
                      </div>
                      <img
                        src={DeleteIcon}
                        alt="Delete Icon"
                        className="deleteWorkshopBtn"
                        onClick={() => handleDeleteWorkshop(workshop.id)}
                      ></img>
                    </td>
                  </tr>
                ))
              ) : isLoading ? (
                <div
                  style={{
                    width: "75%",
                    position: "absolute",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    textAlign: "center",
                    marginTop: "5em",
                  }}
                >
                  <Lottie options={lottieOptions} height={200} width={400} />
                  <h4
                    style={{
                      color: "#0D4C86",
                    }}
                  >
                    LOADING
                  </h4>
                  <p
                    style={{
                      color: "#0D4C86",
                    }}
                  >
                    Processing your request, please wait...
                  </p>
                </div>
              ) : (
                <div
                  style={{
                    width: "75%",
                    position: "absolute",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    textAlign: "center",
                    marginTop: "5em",
                  }}
                >
                  <div>
                    <img
                      src={NotepadPencil}
                      alt="Data not found icon"
                      width={350}
                    />
                  </div>
                  <h4
                    style={{
                      color: "#0D4C86",
                    }}
                  >
                    You have not written any workshop yet
                  </h4>
                  <p
                    style={{
                      color: "#0D4C86",
                    }}
                  >
                    Add new workshop to start..
                  </p>
                </div>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default WorkshopList;
